import { Link } from 'react-router-dom';
import './styles.css';

export default function MemoryDotHome() {
  return (
    <div className="memory-dot-home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="gradient-text">Memory Dot Puzzle</span>
            </h1>
            <p className="hero-subtitle">
              Train Your Memory & Focus
            </p>
            <p className="hero-description">
              A comprehensive brain training app featuring 5 scientifically-designed cognitive games. 
              Challenge yourself daily and track your progress with detailed statistics.
            </p>
            <div className="hero-buttons">
              <a 
                href="https://apps.apple.com/app/memory-dot-puzzle" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                Download on App Store
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.neerajkumar.memorydot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                Get it on Google Play
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Game Modes Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">5 Brain Training Games</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Memory Grid</h3>
              <p>Remember colored dot positions on a grid. Customizable sizes (3×3 to 6×6) with daily challenges.</p>
              <div className="badge-free">FREE</div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🐰</div>
              <h3>Reflex Tap</h3>
              <p>Test your reaction speed with bunny targets. Configurable difficulty levels and smooth animations.</p>
              <div className="badge-premium">PREMIUM</div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>Focus Match</h3>
              <p>Match color-symbol pairs from memory. Multiple difficulty presets with shuffled positions.</p>
              <div className="badge-premium">PREMIUM</div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👈</div>
              <h3>Speed Swipe</h3>
              <p>Memorize and repeat swipe sequences. Real gesture recognition with animated displays.</p>
              <div className="badge-premium">PREMIUM</div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌈</div>
              <h3>Stroop Test</h3>
              <p>Classic cognitive interference training. Color-word mismatch challenges at multiple levels.</p>
              <div className="badge-premium">PREMIUM</div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">Key Features</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">📅</div>
              <h3>Daily Challenges</h3>
              <p>Unique memory challenges every day to keep your brain sharp</p>
            </div>
            <div className="step">
              <div className="step-number">📊</div>
              <h3>Progress Tracking</h3>
              <p>Detailed statistics and performance analytics to monitor growth</p>
            </div>
            <div className="step">
              <div className="step-number">⚙️</div>
              <h3>Customizable</h3>
              <p>Adjust difficulty, timing, and game parameters to your needs</p>
            </div>
            <div className="step">
              <div className="step-number">🔒</div>
              <h3>Privacy First</h3>
              <p>All data stored locally - no tracking or data collection</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Features Section */}
      <section className="premium">
        <div className="container">
          <div className="premium-content">
            <div className="premium-badge">⭐ Premium</div>
            <h2 className="section-title">Unlock Your Full Potential</h2>
            <p className="premium-subtitle">Lifetime access for just ₹349</p>
            <div className="premium-features">
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>All 5 Game Modes</span>
              </div>
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>Advanced Difficulty Levels</span>
              </div>
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>Detailed Statistics Dashboard</span>
              </div>
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>No Advertisements</span>
              </div>
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>Unlimited Retries</span>
              </div>
              <div className="premium-item">
                <span className="checkmark">✓</span>
                <span>All Future Updates</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technical Highlights */}
      <section className="technical">
        <div className="container">
          <h2 className="section-title">Scientifically Designed</h2>
          <div className="tech-grid">
            <div className="tech-item">
              <div className="tech-icon">🧩</div>
              <h4>Working Memory</h4>
              <p>Enhance your ability to hold and manipulate information</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">👁️</div>
              <h4>Visual Processing</h4>
              <p>Improve how your brain processes visual information</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">⚡</div>
              <h4>Reaction Time</h4>
              <p>Speed up your response to stimuli and challenges</p>
            </div>
            <div className="tech-item">
              <div className="tech-icon">🎯</div>
              <h4>Attention Control</h4>
              <p>Strengthen your ability to focus and concentrate</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2 className="cta-title">Start Your Brain Training Journey Today</h2>
          <p className="cta-description">
            Download Memory Dot Puzzle and unlock your mental potential
          </p>
          <div className="cta-buttons">
            <a 
              href="https://apps.apple.com/app/memory-dot-puzzle" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-large btn-primary"
            >
              <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              Download on App Store
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.neerajkumar.memorydot" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-large btn-secondary"
            >
              <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              Get it on Google Play
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Memory Dot Puzzle</h3>
              <p>Train your brain, one dot at a time! 🧠✨</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <nav className="footer-nav">
                <Link to="/memory-dot/support">Support</Link>
                <Link to="/memory-dot/privacy-policy">Privacy Policy</Link>
                <Link to="/memory-dot/terms-and-conditions">Terms & Conditions</Link>
              </nav>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>
                <a href="mailto:sainineeraj1234@gmail.com">sainineeraj1234@gmail.com</a>
              </p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Memory Dot Puzzle. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
